import { Component } from 'react';
import Loading from '../../../components/Loading';
import { withTranslation } from 'react-i18next';
import { setConfigsQuery } from '../../../queries/global';

function cleanUrl(url) {
    if (!url) return '';
    let match = null;
    if (url.startsWith('sc-domain')) {
        match = url.match(/sc-domain:(\w+)\.com/);
    } else {
        match = url.match(/www\.(\w+)\.com/);
    }
    return match ? match[1] : null;
}

class BrandedTerms extends Component {
    constructor(props) {
        super();

        this.updateInput = this.updateInput.bind(this);
        this.onSubmit = this.onSubmit.bind(this);

        this.activeDomain = props.domains?.find((item) => item.status);
        this.state = {
            branded_terms: cleanUrl(this.activeDomain?.url),
            isLoadingBrands: false,
        };
    }

    onSubmit(e, value) {
        e.preventDefault();
        if (!this.state.branded_terms) {
            return this.props.handleNext();
        }

        const params = {
            domain_id: this.activeDomain?.pk,
            branded_terms: value ?? this.state.branded_terms,
        };

        this.setState({ isLoadingBrands: true });

        setConfigsQuery(params)
            .then((res) => res.json())
            .then(() => {
                this.props.handleNext();
            })
            .catch((err) =>
                this.setState({
                    message: err.message ?? 'Something went wrong.',
                    message_tags: 'error',
                }),
            )
            .finally(() => {
                this.setState({ isLoadingBrands: false });
            });
    }

    updateInput(e) {
        this.setState({ branded_terms: e.target.value });
    }

    render() {
        const { t } = this.props;

        return (
            <>
                <div className="padding-x-20">
                    <div className="onboarding-step-8">
                        {this.activeDomain ? (
                            <div
                                className="Timeline"
                                style={{ height: '100%', minHeight: '150px', position: 'relative' }}
                            >
                                <div>
                                    <div className="row mr-10 align-items-start">
                                        <div className="col-3 text-field">
                                            <label className="form-label">
                                                {t('onboarding.step_7.domain')}
                                            </label>
                                            <div>{this.activeDomain?.url}</div>
                                        </div>
                                        <div className="col-9 text-field">
                                            <label
                                                htmlFor="exampleInputEmail1"
                                                className="form-label"
                                            >
                                                {t('onboarding.step_7.branded_terms')}
                                            </label>
                                            <input
                                                name="branded_terms"
                                                className="form-control"
                                                onChange={this.updateInput}
                                                value={this.state.branded_terms ?? ''}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            t('onboarding.step_7.activate_domain')
                        )}
                        {this.state.message && (
                            <div className={`onboarding-message-${this.state.message_tags}`}>
                                {this.state.message}
                            </div>
                        )}
                    </div>
                </div>
                <div className="onboarding-container-item-body-footer ">
                    <button className="onboarding-skip-btn" onClick={() => this.props.handleBack()}>
                        {t('onboarding.back')}
                    </button>
                    <button
                        className="onboarding-btn-next"
                        disabled={this.state.isLoadingBrands}
                        onClick={this.onSubmit}
                    >
                        {this.state.branded_terms
                            ? t('onboarding.save_and_next')
                            : t('onboarding.next')}
                        {this.state.isLoadingBrands && <Loading onlyPreloader />}
                    </button>
                </div>
            </>
        );
    }
}

export default withTranslation()(BrandedTerms);
